import React from "react";
import { motion } from "framer-motion";
import fondo6 from "../../assets/images/fondo6.jpg";
import "../../assets/styles/Asesoria.css";

function PoliticaPrivacidad() {
  return (
    <main
      className="py-6 px-6 flex items-center justify-center"
      style={{
        backgroundImage: `url(${fondo6})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-white bg-opacity-95 shadow-2xl rounded-3xl p-10 max-w-5xl space-y-6 text-justify">
          <h2 className="text-3xl font-extrabold text-center text-green-900 mb-4">
            POLÍTICA DE PRIVACIDAD – NAF ESPE
          </h2>
          <p className="text-center text-sm text-gray-600">
            Última actualización: 9/07/2025
          </p>

          <p>
            En cumplimiento con los principios de transparencia, confidencialidad
            y protección de datos, el Núcleo de Apoyo Contable y Fiscal (NAF) de
            la Universidad de las Fuerzas Armadas – ESPE, presenta la siguiente
            Política de Privacidad aplicable a la recolección y uso de datos
            personales dentro del marco de los servicios que ofrece en conjunto
            con el Servicio de Rentas Internas (SRI) del Ecuador.
          </p>

          <h3 className="font-bold text-lg">1. Responsable del Tratamiento de Datos</h3>
          <p>
            El responsable del tratamiento de los datos personales recolectados
            es el proyecto NAF – ESPE, con domicilio en [Dirección institucional
            de la sede], dentro del marco del convenio académico con el SRI.
          </p>

          <h3 className="font-bold text-lg">2. Datos que Se Recogen</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>Nombres y apellidos.</li>
            <li>Número de cédula o RUC.</li>
            <li>Correo electrónico y número telefónico.</li>
            <li>Información tributaria básica (tipo de régimen, estado del RUC, obligaciones, etc.).</li>
            <li>Actividad económica o giro del negocio.</li>
            <li>Otra información necesaria para la orientación tributaria brindada.</li>
          </ul>

          <h3 className="font-bold text-lg">3. Finalidad del Tratamiento</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>Brindar orientación tributaria y contable personalizada.</li>
            <li>Llevar registros estadísticos y académicos del proyecto.</li>
            <li>Realizar seguimiento a los casos atendidos.</li>
            <li>Evaluar la calidad del servicio prestado.</li>
            <li>Cumplir con los compromisos del convenio NAF – SRI.</li>
          </ul>

          <h3 className="font-bold text-lg">4. Confidencialidad y Seguridad de la Información</h3>
          <p>
            Toda la información recopilada será tratada con estricta
            confidencialidad y únicamente por personal autorizado del NAF. Se han
            implementado medidas técnicas y administrativas para proteger los
            datos contra accesos no autorizados, pérdida o alteración.
          </p>

          <h3 className="font-bold text-lg">5. No Transferencia a Terceros</h3>
          <p>
            Los datos personales no serán vendidos, compartidos ni transferidos a
            terceros, salvo requerimiento expreso de autoridad competente, o si es
            necesario para fines académicos conforme a lo establecido en el
            convenio NAF – SRI.
          </p>

          <h3 className="font-bold text-lg">6. Derechos del Titular de los Datos</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>Acceder a la información proporcionada.</li>
            <li>Solicitar su rectificación o actualización.</li>
            <li>Revocar el consentimiento del tratamiento.</li>
            <li>
              Solicitar la eliminación de sus datos, salvo cuando existan razones
              académicas, legales o contractuales que lo impidan.
            </li>
          </ul>
          <p className="italic text-sm text-gray-600">
            Para ejercer estos derechos puede comunicarse al correo: [correo institucional NAF].
          </p>

          <h3 className="font-bold text-lg">7. Conservación de los Datos</h3>
          <p>
            Los datos personales se conservarán durante el tiempo necesario para
            cumplir con las finalidades descritas y conforme a la normativa
            académica y tributaria vigente.
          </p>

          <h3 className="font-bold text-lg">8. Cambios en la Política de Privacidad</h3>
          <p>
            El NAF se reserva el derecho de actualizar esta política en cualquier
            momento. Cualquier cambio será notificado a través de los canales
            oficiales del proyecto.
          </p>

          <h3 className="font-bold text-lg">9. Aceptación</h3>
          <p>
            El uso de los servicios del NAF implica el conocimiento y aceptación
            de esta Política de Privacidad.
          </p>
        </div>
      </motion.div>
    </main>
  );
}

export default PoliticaPrivacidad;
